import { render, staticRenderFns } from "./UIButton.vue?vue&type=template&id=5c17252c"
import script from "./UIButton.vue?vue&type=script&lang=ts"
export * from "./UIButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports